module.exports = __webpack_public_path__ + "img/red.bdc96506.svg";